// extracted by mini-css-extract-plugin
export default {"content":"Wrapper_content__GKU6D"};